// extracted by mini-css-extract-plugin
export default {"root":"classes_root__HuQ0P","left-side-menu":"classes_left-side-menu__+PLdx","body":"classes_body__Ttbf4","content":"classes_content__cO7kR"};